import { SubCategory, TopLevelCategory } from "@robe/core-types/category";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { fillMissingLocalizedCategoryNames } from "./utils";

export interface GetSubCategoryResponse {
  subCategory: SubCategory;
  topLevelCategory: TopLevelCategory;
}

export const getSubCategory = (id: number, core: XcoreCore): BaseApiRequest<GetSubCategoryResponse> =>
  core
    .fetch(`/api/category/subcategory/${id}`)
    .then((res) => res.json())
    .then((res: GetSubCategoryResponse) => ({
      topLevelCategory: res.topLevelCategory,
      subCategory: fillMissingLocalizedCategoryNames(res.subCategory),
    }));
